import { render, staticRenderFns } from "./SubcategoriesBar.vue?vue&type=template&id=f25220c8&scoped=true&"
import script from "./SubcategoriesBar.vue?vue&type=script&lang=js&"
export * from "./SubcategoriesBar.vue?vue&type=script&lang=js&"
import style0 from "./styles/SubcategoriesBar.scss?vue&type=style&index=0&id=f25220c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25220c8",
  null
  
)

export default component.exports